import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-071ff0ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { class: "Login_Container" }
const _hoisted_3 = { class: "Login_Wrapper" }
const _hoisted_4 = { class: "Login_Form" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Login_Form_Title" }, "パスワード再設定メール送信完了", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("入力されたメールアドレスにパスワード再設定の通知メールを送信しました。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メール記載のリンクからパスワードの再設定を行ってください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("※ログイン後はユーザー情報画面からパスワードを更新してください。")
], -1))

import BtnGreen from "../components/atoms/button/BtnGreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordMailSubmitted',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(BtnGreen, { class: "Login_Form_BtnGreen" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/",
                style: {"color":"white"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("ログイン画面へ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})